export const formatCVV = (value: string): string => {
  return value.replace(/[^0-9]/gi, '').slice(0, 3);
};
